<template>
    <div class="top-banner">
        <div>
            <div class="header-row">
                <img class="header-icon" src="../../assets/rb_7542.png" />
                <h2 class="section-title">
                    รายได้จากการขายสินค้าและบริการของชุมชน
                </h2>
            </div>
            <div class="line_blue"></div>
            <ColumnChart />
            <br />
            <div class="row">
                <div class="col-md-12 py_5px">
                    <div class="chart sales-table-panel">
                        <div class="tab-switcher">
                            <div
                                :class="
                                    activeTab === 'sales'
                                        ? 'tab_active'
                                        : 'tap_notactive'
                                "
                                @click="activeTab = 'sales'"
                                style="cursor: pointer"
                            >
                                รายการขายผลิตภัณฑ์
                            </div>
                            <div
                                :class="
                                    activeTab === 'preorders'
                                        ? 'tab_active'
                                        : 'tap_notactive'
                                "
                                @click="activeTab = 'preorders'"
                                style="cursor: pointer"
                            >
                                รายการจองผลิตภัณฑ์.
                            </div>
                        </div>
                        <h3
                            v-if="activeTab === 'sales'"
                            style="margin-bottom: 10px"
                        >
                            รายการขายผลิตภัณฑ์.
                        </h3>
                        <h3 v-else style="margin-bottom: 10px">
                            รายการจองผลิตภัณฑ์
                        </h3>
                        <!-- Table Sale of Admin -->
                        <div v-if="activeTab === 'sales'">
                            <div
                                v-if="isLoading"
                                class="alert alert-info"
                                style="margin-bottom: 10px"
                            >
                                กำลังโหลดข้อมูลรายการขาย...
                            </div>
                            <div
                                v-else-if="fetchError"
                                class="alert alert-danger"
                                style="margin-bottom: 10px"
                            >
                                {{ getFetchErrorMessage() }}
                            </div>
                            <div v-else-if="isAdminUser()">
                                <div
                                    v-if="!tableData.length"
                                    class="alert alert-info"
                                    style="margin-bottom: 10px"
                                >
                                    ไม่พบข้อมูลรายการขาย
                                </div>
                                <div
                                    class="table-responsive table-container"
                                    v-else
                                >
                                    <table
                                        class="table table-striped"
                                        style="width: 100%; font-size: 14px"
                                    >
                                        <thead>
                                            <tr>
                                                <th
                                                    class="text-center"
                                                    style="width: 5%"
                                                >
                                                    ลำดับ
                                                </th>
                                                <th style="width: 10%">
                                                    วันที่ซื้อ
                                                </th>
                                                <th style="width: 10%">
                                                    รายการสินค้า
                                                </th>
                                                <th style="width: 5%">ราคา</th>
                                                <th style="width: 6%">
                                                    จํานวน
                                                </th>
                                                <th style="width: 8%">
                                                    รวมทั้งสิ้น
                                                </th>
                                                <th style="width: 15%">
                                                    ข้อมูลลูกค้า
                                                </th>
                                                <th style="width: 15%">
                                                    ข้อมูลชุมชน
                                                </th>
                                                <th style="width: 15%">
                                                    ข้อมูลการจัดส่ง
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(
                                                    item, index
                                                ) in tableData"
                                                :key="item.row_key"
                                            >
                                                <td class="text-center">
                                                    {{ index + 1 }}

                                                    <button
                                                        style="margin-top: 10px"
                                                        class="btn btn-primary"
                                                        @click="
                                                            openModalWithData(
                                                                item,
                                                            )
                                                        "
                                                    >
                                                        รายละเอียด
                                                    </button>
                                                </td>
                                                <td>
                                                    <span
                                                        v-html="
                                                            formatThaiDateTime(
                                                                item.payment_submit,
                                                            ).replace(
                                                                '\n',
                                                                '<br>',
                                                            )
                                                        "
                                                    ></span>
                                                </td>
                                                <td>{{ item.product_name }}</td>
                                                <td>
                                                    {{
                                                        formatNumber(
                                                            item.price_for_one,
                                                        )
                                                    }}
                                                </td>
                                                <td>
                                                    {{ item.quantity }}
                                                </td>
                                                <td>
                                                    {{
                                                        formatNumber(
                                                            item.total_price,
                                                        )
                                                    }}
                                                </td>
                                                <!-- Customer Detail -->
                                                <td>
                                                    <ul
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <li
                                                            style="
                                                                font-size: 14px !important;
                                                            "
                                                        >
                                                            <strong
                                                                style="
                                                                    font-weight: 500;
                                                                "
                                                            >
                                                                ชื่อลูกค้า :
                                                            </strong>
                                                            {{
                                                                item.payment_fullname
                                                            }}
                                                        </li>
                                                        <li
                                                            style="
                                                                font-size: 14px !important;
                                                            "
                                                        >
                                                            <strong
                                                                style="
                                                                    font-weight: 500;
                                                                "
                                                                >ที่อยู่ :
                                                            </strong>

                                                            <div
                                                                v-if="
                                                                    item.data_source ===
                                                                    'preorders'
                                                                "
                                                            >
                                                                {{
                                                                    item.delivery_address
                                                                }}
                                                            </div>
                                                            <div v-else>
                                                                {{
                                                                    item.payment_address
                                                                }}
                                                                {{
                                                                    item.payment_tambon
                                                                }}
                                                                {{
                                                                    item.payment_ampher
                                                                }}
                                                                {{
                                                                    item.payment_province
                                                                }}
                                                                {{
                                                                    formatZipcode(
                                                                        item.payment_zipcode,
                                                                    )
                                                                }}
                                                            </div>
                                                        </li>
                                                        <li
                                                            style="
                                                                font-size: 14px !important;
                                                            "
                                                        >
                                                            <strong
                                                                style="
                                                                    font-weight: 500;
                                                                "
                                                                >เบอร์โทร :
                                                            </strong>
                                                            {{
                                                                item.payment_telephone
                                                            }}
                                                        </li>
                                                        <li
                                                            style="
                                                                font-size: 14px !important;
                                                            "
                                                        >
                                                            <strong
                                                                style="
                                                                    font-weight: 500;
                                                                "
                                                                >ชำระผ่าน :
                                                            </strong>
                                                            {{
                                                                item.payment_method
                                                            }}
                                                        </li>
                                                    </ul>
                                                </td>
                                                <!-- end of customer detail -->
                                                <!-- Community Detail By admin -->
                                                <td>
                                                    <ul
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <li
                                                            style="
                                                                font-size: 14px !important;
                                                            "
                                                        >
                                                            <strong
                                                                style="
                                                                    font-weight: 500;
                                                                "
                                                            >
                                                                ชื่อชุมชน :
                                                            </strong>
                                                            {{
                                                                item.community_name
                                                            }}
                                                        </li>
                                                        <li
                                                            style="
                                                                font-size: 14px !important;
                                                            "
                                                        >
                                                            <strong
                                                                style="
                                                                    font-weight: 500;
                                                                "
                                                            >
                                                                ผู้ประสานงาน :
                                                            </strong>
                                                            {{
                                                                item.community_contact
                                                            }}
                                                        </li>
                                                        <li
                                                            style="
                                                                font-size: 14px !important;
                                                            "
                                                        >
                                                            <strong
                                                                style="
                                                                    font-weight: 500;
                                                                "
                                                            >
                                                                ที่อยู่ชุมชน :
                                                            </strong>
                                                            {{
                                                                item.community_address
                                                            }}
                                                        </li>
                                                        <li
                                                            style="
                                                                font-size: 14px !important;
                                                            "
                                                        >
                                                            <strong
                                                                style="
                                                                    font-weight: 500;
                                                                "
                                                            >
                                                                เบอร์โทร :
                                                            </strong>
                                                            {{
                                                                item.community_telephone
                                                            }}
                                                        </li>
                                                    </ul>
                                                </td>
                                                <!-- end of Community Detail By admin -->
                                                <!-- รหัสพัสดุ -->
                                                <td>
                                                    <ul
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <li
                                                            style="
                                                                font-size: 14px !important;
                                                            "
                                                        >
                                                            <strong
                                                                style="
                                                                    font-weight: 500;
                                                                "
                                                            >
                                                                เลขพัสดุ :
                                                            </strong>
                                                            {{
                                                                item.track_number
                                                            }}
                                                        </li>
                                                        <li
                                                            style="
                                                                font-size: 14px !important;
                                                            "
                                                        >
                                                            <strong
                                                                style="
                                                                    font-weight: 500;
                                                                "
                                                            >
                                                                บริษัทขนส่ง :
                                                            </strong>
                                                            {{
                                                                item.delivery_company_name
                                                            }}
                                                        </li>
                                                    </ul>
                                                </td>
                                                <!-- สถานะพัสดุ -->
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-if="showModal" class="modal-overlay">
                                    <div class="modal-content">
                                        <button
                                            class="close-button"
                                            @click="closeModal"
                                        >
                                            ×
                                        </button>
                                        <h3>รายละเอียดคำสั่งซื้อ</h3>
                                        <hr />
                                        <div v-if="selectedPayment" class="row">
                                            <div class="col-md-6 col-sm-12">
                                                <strong>ข้อมูลลูกค้า</strong>
                                                <ul
                                                    style="
                                                        font-size: 14px !important;
                                                    "
                                                >
                                                    <li
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                        >
                                                            ชื่อลูกค้า :
                                                        </strong>
                                                        {{
                                                            selectedPayment.payment_fullname
                                                        }}
                                                    </li>
                                                    <li
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                            >ที่อยู่ :
                                                        </strong>
                                                        <div
                                                            v-if="
                                                                selectedPayment.data_source ===
                                                                'preorders'
                                                            "
                                                        >
                                                            {{
                                                                selectedPayment.delivery_address
                                                            }}
                                                        </div>
                                                        <div v-else>
                                                            {{
                                                                selectedPayment.payment_address
                                                            }}
                                                            {{
                                                                selectedPayment.payment_tambon
                                                            }}
                                                            {{
                                                                selectedPayment.payment_ampher
                                                            }}
                                                            {{
                                                                selectedPayment.payment_province
                                                            }}
                                                            {{
                                                                formatZipcode(
                                                                    selectedPayment.payment_zipcode,
                                                                )
                                                            }}
                                                        </div>
                                                    </li>
                                                    <li
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                            >เบอร์โทร :
                                                        </strong>
                                                        {{
                                                            selectedPayment.payment_telephone
                                                        }}
                                                    </li>
                                                    <li
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                            >ชำระผ่าน :
                                                        </strong>
                                                        {{
                                                            selectedPayment.payment_method
                                                        }}
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-md-6 col-sm-12">
                                                <strong>ข้อมูลชุมชน</strong>
                                                <ul
                                                    style="
                                                        font-size: 14px !important;
                                                    "
                                                >
                                                    <li
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                        >
                                                            ชื่อชุมชน :
                                                        </strong>
                                                        {{
                                                            selectedPayment.community_name
                                                        }}
                                                    </li>
                                                    <li
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                        >
                                                            ผู้ประสานงาน :
                                                        </strong>
                                                        {{
                                                            selectedPayment.community_contact
                                                        }}
                                                    </li>
                                                    <li
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                        >
                                                            ที่อยู่ชุมชน :
                                                        </strong>
                                                        {{
                                                            selectedPayment.community_address
                                                        }}
                                                    </li>
                                                    <li
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                        >
                                                            เบอร์โทร :
                                                        </strong>
                                                        {{
                                                            selectedPayment.community_telephone
                                                        }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <br />
                                        <div class="row">
                                            <div
                                                class="mt-3 col-md-6 col-sm-12"
                                            >
                                                <strong
                                                    >ข้อมูลการสั่งซื้อ</strong
                                                >
                                                <ul
                                                    style="
                                                        font-size: 14px !important;
                                                    "
                                                >
                                                    <li
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                        >
                                                            ผลิตภัณฑ์ :
                                                        </strong>
                                                        {{
                                                            selectedPayment.product_name
                                                        }}
                                                    </li>
                                                    <li
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                        >
                                                            ราคา :
                                                        </strong>
                                                        {{
                                                            formatNumber(
                                                                selectedPayment.price_for_one,
                                                            )
                                                        }}
                                                        บาท
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                            >จำนวน</strong
                                                        >
                                                        {{
                                                            selectedPayment.quantity
                                                        }}
                                                        ชิ้น
                                                    </li>
                                                    <li
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                        >
                                                            ราคารวมทั้งสิ้น :
                                                        </strong>
                                                        {{
                                                            selectedPayment.total_price
                                                        }}
                                                        บาท
                                                    </li>
                                                    <li
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                        >
                                                            วันที่สั่งซื้อ :
                                                        </strong>
                                                        <span
                                                            v-html="
                                                                formatThaiDateTime(
                                                                    selectedPayment.payment_submit,
                                                                )
                                                            "
                                                        ></span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div
                                                class="mt-3 col-md-6 col-sm-12"
                                            >
                                                <strong>ข้อมูลการจัดส่ง</strong>
                                                <ul
                                                    style="
                                                        font-size: 14px !important;
                                                    "
                                                >
                                                    <li
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                        >
                                                            เลขพัสดุ :
                                                        </strong>
                                                        {{
                                                            selectedPayment.track_number
                                                        }}
                                                    </li>
                                                    <li
                                                        style="
                                                            font-size: 14px !important;
                                                        "
                                                    >
                                                        <strong
                                                            style="
                                                                font-weight: 500;
                                                            "
                                                        >
                                                            บริษัทขนส่ง :
                                                        </strong>
                                                        {{
                                                            selectedPayment.delivery_company_name
                                                        }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <CommunitySale />
                            </div>
                        </div>
                        <!-- End of Table Sale of Admin -->
                        <div v-else>
                            <PreordersTable />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 py_5px">
                    <div class="chart">
                        <h3 style="margin-bottom: 10px">กิจกรรมชุมชน</h3>
                        <BarChart type_chart="active" />
                    </div>
                </div>
                <div class="col-md-4 py_5px">
                    <div class="chart">
                        <h3 style="margin-bottom: 10px">
                            เส้นทางการท่องเที่ยว
                        </h3>
                        <BarChart type_chart="route" />
                    </div>
                </div>
                <div class="col-md-4 py_5px">
                    <div class="chart">
                        <h3 style="margin-bottom: 10px">
                            โปรแกรมการท่องเที่ยว
                        </h3>
                        <BarChart type_chart="program" />
                    </div>
                </div>
                <div class="col-md-4 py_5px">
                    <div class="chart">
                        <h3 style="margin-bottom: 10px">ไกด์ท้องถิ่น</h3>
                        <BarChart type_chart="guide" />
                    </div>
                </div>
                <div class="col-md-4 py_5px">
                    <div class="chart">
                        <h3 style="margin-bottom: 10px">ที่พัก</h3>
                        <BarChart type_chart="hotel" />
                    </div>
                </div>
                <div class="col-md-4 py_5px">
                    <div class="chart">
                        <h3 style="margin-bottom: 10px">ร้านอาหาร</h3>
                        <BarChart type_chart="restaurant" />
                    </div>
                </div>
            </div>
        </div>
        <div class="section-space-top">
            <div class="header-row">
                <img
                    class="header-icon header-icon-large"
                    src="../../assets/rb_256.png"
                />
                <h2 class="section-title">ข้อมูลพฤติกรรมของนักท่องเที่ยว</h2>
            </div>
            <div class="line_blue"></div>
            <div class="row">
                <div class="col-md-3 py_5px">
                    <div class="chart">
                        <h3 style="margin-bottom: 10px">
                            ความสนใจสินค้า (คลิ๊ก)
                        </h3>
                        <BarChart type_chart="BehaviorProductCommunity" />
                    </div>
                </div>
                <div class="col-md-3 py_5px">
                    <div class="chart">
                        <h3 style="margin-bottom: 10px">
                            ความต้องการสินค้า (ซื้อหรือจอง)
                        </h3>
                        <BarChart type_chart="Reservation" />
                    </div>
                </div>
                <div class="col-md-3 py_5px">
                    <div class="chart">
                        <h3 style="margin-bottom: 10px">
                            ความสนใจในบริการ (คลิ๊ก)
                        </h3>
                        <BarChart type_chart="service" />
                    </div>
                </div>
                <div class="col-md-3 py_5px">
                    <div class="chart">
                        <h3 style="margin-bottom: 10px">
                            ความต้องการในบริการ (ซื้อหรือจอง)
                        </h3>
                        <BarChart type_chart="Reservation_service" />
                    </div>
                </div>
                <div class="col-md-12 py_5px">
                    <div class="chart">
                        <h3 style="margin-bottom: 10px">
                            การเข้าถึงสินค้าและบริการของชุมชน
                        </h3>
                        <MapComponent />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ColumnChart from "./Chart/ColumnChart.vue";
import BarChart from "./Chart/BarChart.vue";
import MapComponent from "./Chart/MapComponent.vue";
import CommunitySale from "./CommunitySale.vue";
import PreordersTable from "./PreordersTable.vue";
import axios from "axios";
import {
    filterOrdersByRoleAndCommunity,
    isAdminRole,
    normalizeCommunityId,
} from "../../utils/communityFilter";
export default {
    name: "CommunityDashboardPage",
    components: {
        ColumnChart: ColumnChart,
        BarChart: BarChart,
        MapComponent: MapComponent,
        CommunitySale,
        PreordersTable,
    },
    data() {
        return {
            activeTab: "sales",
            tableData: [],
            showModal: false,
            selectedPayment: null,
            fetchError: null,
            isLoading: false,
        };
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            this.isLoading = true;
            try {
                this.fetchError = null; // Reset error state

                const community_id = localStorage.getItem("community_id");
                const role_id = localStorage.getItem("role_id");
                const scopedCommunityId = normalizeCommunityId(community_id);
                const isAdmin = isAdminRole(role_id);
                const apiData = [];

                if (!isAdmin && scopedCommunityId === null) {
                    this.tableData = [];
                    this.fetchError = new Error("missing_community_scope");
                    return;
                }

                if (isAdmin) {
                    const res = await axios.get(
                        "https://openapi.kims-rmuti.com/api/SaleTable",
                    );
                    // apiData.push(...res.data);
                    if (res.data && Array.isArray(res.data)) {
                        apiData.push(...res.data);
                    }
                } else {
                    const res = await axios.get(
                        `https://openapi.kims-rmuti.com/api/SaleTable?community=${scopedCommunityId}`,
                    );
                    // apiData.push(...res.data);
                    if (res.data && Array.isArray(res.data)) {
                        apiData.push(...res.data);
                    }
                }

                const preordersRes = await axios.get(
                    "https://api.xn--42cf1c1az5dtau6v.com/api/preorders",
                );

                // const purchaseOrders = preordersRes.data.filter(item =>
                //     item.order_type === "purchase"
                // );

                // apiData.push(...purchaseOrders);

                let purchaseOrders = [];
                if (preordersRes.data) {
                    const allOrders = Array.isArray(preordersRes.data)
                        ? preordersRes.data
                        : preordersRes.data.data || [];

                    purchaseOrders = allOrders.filter(
                        (item) => item && item.order_type === "purchase",
                    );
                    purchaseOrders = filterOrdersByRoleAndCommunity(
                        purchaseOrders,
                        role_id,
                        scopedCommunityId,
                    );
                }

                const processedPurchaseOrders = purchaseOrders.map((item) => {
                    let productName = "ไม่ระบุ";
                    let communityName = "ไม่ระบุ";
                    let communityContact = "ไม่ระบุ";
                    let communityAddress = "ไม่ระบุ";
                    let communityTelephone = "ไม่ระบุ";

                    try {
                        if (item?.external_product_data) {
                            const epd = JSON.parse(item.external_product_data);
                            productName =
                                epd?.name ||
                                epd?.external_data?.product_name ||
                                productName;
                            communityName =
                                epd?.community_name ||
                                epd?.external_data?.community_name ||
                                communityName;
                            communityContact =
                                epd?.community_contact ||
                                epd?.external_data?.community_contact ||
                                communityContact;
                            communityAddress =
                                epd?.community_address ||
                                epd?.external_data?.community_address ||
                                communityAddress;
                            communityTelephone =
                                epd?.community_telephone ||
                                epd?.external_data?.community_telephone ||
                                communityTelephone;
                        }
                        if (item?.product_community?.community_name) {
                            communityName =
                                item.product_community.community_name;
                        }
                    } catch (_) {
                        // ignore parse error
                    }

                    return {
                        product_name: productName,
                        product_quantity: parseInt(item?.quantity) || 0,
                        price_for_one: parseFloat(item?.unit_price) || 0,
                        total_price: parseFloat(item?.total_price) || 0,
                        community_name: communityName,
                        community_contact: communityContact,
                        community_address: communityAddress,
                        community_telephone: communityTelephone,
                        delivery_address: item?.delivery_address || "ไม่ระบุ",
                        payment_id: item?.id || null, // Use order ID as payment_id
                        payment_submit:
                            item?.created_at || item?.updated_at || null,
                        payment_method:
                            item?.payment_method || "สั่งซื้อออนไลน์",
                        payment_fullname:
                            item?.customer_name || "ลูกค้าออนไลน์",
                        payment_address: item?.shipping_address || "",
                        payment_province: item?.shipping_province || "",
                        payment_ampher: item?.shipping_district || "",
                        payment_tambon: item?.shipping_subdistrict || "",
                        payment_zipcode: this.formatZipcode(
                            item?.shipping_zipcode,
                        ),
                        payment_telephone: item?.customer_phone || "",
                        track_number: item?.tracking_number || "",
                        delivery_company_name: item?.delivery_company || "",
                        delivery_company_id: item?.delivery_company_id || "",
                        data_source: "preorders", // Indicate data source
                    };
                });

                apiData.push(...processedPurchaseOrders);

                this.tableData = apiData.map((item, index) => {
                    const paymentId = item.payment_id || item.id || "";
                    const paymentSubmit = item.payment_submit || "ไม่ระบุ";
                    const productName = item.product_name || "ไม่ระบุ";
                    const paymentFullname = item.payment_fullname || "ไม่ระบุ";

                    return {
                        row_key:
                            paymentId ||
                            `${item.data_source || "sale_table"}-${paymentSubmit}-${productName}-${paymentFullname}-${index}`,
                        payment_id: paymentId,
                        product_name: productName,
                        quantity: item.product_quantity || 0,
                        price_for_one: item.price_for_one || 0,
                        total_price: item.total_price || 0,
                        community_name: item.community_name || "ไม่ระบุ",
                        community_contact: item.community_contact || "ไม่ระบุ",
                        community_address: item.community_address || "ไม่ระบุ",
                        community_telephone:
                            item.community_telephone || "ไม่ระบุ",
                        payment_submit: paymentSubmit,
                        payment_method: item.payment_method || "ไม่ระบุ",
                        payment_fullname: paymentFullname,
                        payment_address: item.payment_address || "ไม่ระบุ",
                        payment_province: item.payment_province
                            ? "จ." + item.payment_province
                            : "",
                        payment_ampher: item.payment_ampher
                            ? "อ." + item.payment_ampher
                            : "",
                        payment_tambon: item.payment_tambon
                            ? "ต." + item.payment_tambon
                            : "",
                        payment_zipcode: this.formatZipcode(
                            item.payment_zipcode,
                        ),
                        payment_telephone: item.payment_telephone || "ไม่ระบุ",
                        track_number: item.track_number || "ยังไม่ขนส่งสินค้า",
                        delivery_company_name:
                            item.delivery_company_name || "ยังไม่ขนส่งสินค้า",
                        data_source: item.data_source || "sale_table", // เพิ่ม field นี้
                    };
                });

                /*

                this.tableData = apiData.map((item) => ({
                    product_name: item.product_name || "ไม่ระบุ",
                    quantity: item.product_quantity || 0,
                    price_for_one: item.price_for_one || 0,
                    total_price: item.total_price || 0,
                    community_name: item.community_name || "ไม่ระบุ",
                    community_contact: item.community_contact || "ไม่ระบุ",
                    community_address: item.community_address || "ไม่ระบุ",
                    community_telephone: item.community_telephone || "ไม่ระบุ",
                    payment_submit: item.payment_submit || "ไม่ระบุ",
                    payment_method: item.payment_method || "ไม่ระบุ",
                    payment_fullname: item.payment_fullname || "ไม่ระบุ",
                    payment_address: item.payment_address || "ไม่ระบุ",
                    payment_province: "จ." + item.payment_province || "",
                    payment_ampher: "อ." + item.payment_ampher || "",
                    payment_tambon: "ต." + item.payment_tambon || "",
                    payment_zipcode: item.payment_zipcode || "",
                    payment_telephone: item.payment_telephone || "ไม่ระบุ",
                    track_number: item.track_number || "ยังไม่ขนส่งสินค้า",
                    delivery_company_name:
                        item.delivery_company_name || "ยังไม่ขนส่งสินค้า",
                }));
                */
            } catch (error) {
                this.fetchError = error;
                console.error("Error fetching data:", error);
            } finally {
                this.isLoading = false;
            }
        },
        formatNumber(value) {
            return new Intl.NumberFormat().format(value);
        },
        formatThaiDateTime(datetime) {
            if (!datetime) return "-";
            const date = new Date(datetime);
            if (Number.isNaN(date.getTime())) {
                return "-";
            }
            const utc = date.getTime() + date.getTimezoneOffset() * 60000;
            const thTime = new Date(utc + 7 * 60 * 60 * 1000);
            if (Number.isNaN(thTime.getTime())) {
                return "-";
            }
            const options = {
                year: "numeric",
                month: "short",
                day: "numeric",
            };
            const timeOptions = {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            };
            const dateStr = thTime.toLocaleDateString("th-TH", options);
            const timeStr = thTime.toLocaleTimeString("th-TH", timeOptions);

            return `${dateStr}\nเวลา ${timeStr} น.`;
        },
        formatZipcode(zipcode) {
            if (zipcode === null || zipcode === undefined) {
                return "";
            }
            return String(zipcode).trim();
        },
        isAdminUser() {
            return isAdminRole(this.getRoleId());
        },
        getFetchErrorMessage() {
            if (this.fetchError?.message === "missing_community_scope") {
                return "ไม่พบขอบเขตชุมชนของผู้ใช้งาน กรุณาเข้าสู่ระบบใหม่";
            }
            return "เกิดข้อผิดพลาดในการดึงข้อมูลรายการขาย";
        },
        getRoleId() {
            return localStorage.getItem("role_id");
        },
        openModalWithData(item) {
            this.selectedPayment = item;
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.selectedPayment = null;
        },
    },
};
</script>

<style scoped>
.top-banner {
    position: relative;
    background-color: #f9f9f9;
    padding: clamp(16px, 3vw, 40px);
}

.header-row {
    display: flex;
    align-items: flex-end;
    gap: 10px;
}

.header-icon {
    height: 60px;
    width: auto;
    object-fit: contain;
    flex-shrink: 0;
}

.header-icon-large {
    height: 80px;
}

.section-title {
    margin: 0;
    font-size: clamp(22px, 3vw, 32px);
    line-height: 1.25;
    word-break: break-word;
}

.section-space-top {
    margin-top: clamp(24px, 4vw, 32px);
}

.sales-table-panel {
    margin-top: 0;
    overflow: auto;
    max-height: 500px;
}

.tab-switcher {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.line_blue {
    margin-top: 13px !important;
    margin-bottom: 20px !important;
    border: 0 !important;
    border-top: 2px solid #206ab0 !important;
}
h3 {
    font-size: 20px;
    font-weight: 500;
    text-align: start;
}

.text_data {
    margin-top: 1rem;
    font-size: 34px;
    font-weight: 600;
    text-align: center;
}

.label_box {
    display: flex;
    background-color: #ffffff;
    padding: 15px 25px;
    border-radius: 5px;
    border: 1px solid #e3e3e3;
    box-shadow: 1px 1px 5px #e3e3e3;
}
.label_box p {
    font-size: 16px;
}

.chart {
    margin-top: 10px;
    padding: 20px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 1px 1px 5px #e3e3e3;
}

.table-container {
    overflow-x: auto;
}

.table-container .table {
    min-width: 980px;
}

.sales-table-panel .table {
    border-collapse: separate;
    border-spacing: 0;
}

.sales-table-panel .table thead th {
    position: sticky;
    top: 0;
    z-index: 3;
    background: #ffffff;
    box-shadow: inset 0 -1px 0 #dee2e6;
}

.py_5px {
    padding-left: 5px !important;
    padding-right: 5px !important;
}

iframe {
    width: 100%;
    height: 800px;
    border: none;
}

.tab_active {
    background-color: #e9eef4 !important;
    color: rgb(32, 106, 176) !important;
    padding: 13px !important;
    font-size: 20px !important;
    border-top: 2px solid !important;
    border-left: 2px solid !important;
    border-radius: 5px 0 0 0 !important;
}

.tap_notactive {
    background-color: #206ab0;
    color: #fff;
    padding: 15px;
    padding-bottom: 13px;
    font-size: 20px;
    border-radius: 0 5px 0 0;
}

.center {
    text-align: center;
}

.sidebar-block {
    padding-bottom: 20px;
    border-bottom: 1px solid #ededed;
    margin-bottom: 20px;
}

.bg_block {
    background-color: #000000;
}

.padd-90-90 {
    padding-top: 70px;
    padding-bottom: 70px;
}

.col-lg-12 {
    padding-right: 25px;
    padding-left: 45px;
}

.popular-img h4 {
    font-weight: 500;
    letter-spacing: 0px;
    padding-bottom: 10px;
    text-shadow: 1px 1px 1px black;
}

.popular-img .vertical-bottom {
    padding: 0px 0px 6px 6px;
    /* text-align:center; */
    backdrop-filter: blur(1px);
}

.c-button.small {
    font-size: 12px;
    padding: 8px 14px;
    -moz-border-radius: 6px;
    border-radius: 6px;
}

.c-button.small span {
    font-weight: 500;
}

.imageSizss {
    width: 100%;
    height: 250px;
}

.img-Commu {
    float: left;
}

.borderCommunity {
    border: 10px solid red;
    padding: 5px;
    width: 100%;
    height: 250px;
    background-color: black;
}

.ppcont {
    width: 1000px;
    height: 600px;
}

#text-spac-page-covid {
    letter-spacing: 0;
}

.imgActivity {
    width: 150px;
    height: 100px;
    text-align: center;
}

.pulse {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    height: 14px;
    width: 14px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: 15px 0px 0px -12px;
    transform: rotateX(55deg);
    z-index: -2;
}

.pulse:after {
    content: "";
    border-radius: 50%;
    height: 40px;
    width: 40px;
    position: absolute;
    margin: -16px 0 0 -13px;
    animation: pulsate 2.5s ease-out;
    animation-iteration-count: infinite;
    opacity: 0;
    background: rgba(94, 190, 255, 0.5);
    box-shadow: 0 0 1px 2px #2d99d3;
    animation-delay: 1.1s;
}

.simple-tab .tab-info {
    border: 1px solid #e9eef4;
    margin-bottom: -30px;
    padding: 14px 14px;
}

.padd-90 {
    padding-bottom: 0px;
}

.grid-content.block-content .hotel-item.style-10 {
    padding-bottom: 0px;
}

.grid-content {
    margin-bottom: 0px;
}

.grid-content .hotel-item {
    margin-bottom: 0px;
}

.detail-wrapper {
    padding: 0px;
    margin-top: -30px;
}

.right-sidebar {
    object-fit: cover;
}

/*-----------scrollll----------------- */
/*
 *  STYLE 1
 */

.scrollbar::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ffffff00;
}

.scrollbar::-webkit-scrollbar {
    width: 8px;
    background-color: #ffffff00;
}

.scrollbar::-webkit-scrollbar-thumb {
    border-radius: 10px;

    background-color: rgb(202, 202, 202);
}

.title_page {
    float: left;
    padding-top: 15px;
    padding-bottom: 15px;
    background: rgba(255, 255, 255, 0.696);
    border-radius: 25px;
}

.scrollbar {
    height: 70vh;
    overflow-y: scroll;
    /* padding: 40px 40px 40px 40px; */
    /* box-shadow: inset 1px 1px 12px #dddddd; */
}

.hotel-item {
    position: relative;
    width: 100%;

    display: inline-block;
    box-shadow: 0px 0px 0px white;
}

.input-style-1.b-50 input {
    font-size: 14px;
    height: 42px;
    padding: 0px 12px 0px 21px;
    color: #000000;
}

@media screen and (max-width: 600px) {
    .col-md-8 {
        padding-bottom: 40px;
    }

    .col-lg-12 {
        padding-right: 15px;
        padding-left: 15px;
    }

    .header-icon {
        height: 44px;
    }

    .header-icon-large {
        height: 52px;
    }

    .section-title {
        font-size: clamp(18px, 5vw, 22px);
    }

    .tab-switcher {
        gap: 6px;
    }

    .tab_active,
    .tap_notactive {
        width: 100%;
        font-size: 16px !important;
        text-align: center;
        border-radius: 8px !important;
        border-left: none !important;
    }

    .tab_active {
        border-top: 2px solid !important;
    }

    .sales-table-panel {
        max-height: 70vh;
        padding: 12px;
    }

    .chart {
        padding: 14px;
    }

    .table-container .table {
        min-width: 760px;
        font-size: 13px !important;
    }
}

@media screen and (max-width: 992px) {
    .py_5px {
        padding-left: 0 !important;
        padding-right: 0 !important;
        margin-bottom: 10px;
    }

    .chart {
        border-radius: 10px;
    }

    .modal-content {
        width: 96%;
        max-width: 96%;
        padding: 1.25rem;
    }

    .close-button {
        top: 0.5rem;
        right: 0.75rem;
        width: 42px;
        font-size: 1.6rem;
    }
}

@media screen and (max-width: 1200px) {
    .top-banner {
        padding: 24px;
    }

    .section-space-top {
        margin-top: 28px;
    }

    .chart {
        padding: 18px;
    }

    .py_5px {
        padding-left: 4px !important;
        padding-right: 4px !important;
    }

    .sales-table-panel {
        max-height: 62vh;
    }

    .table-container .table {
        min-width: 920px;
    }
}

@media screen and (max-width: 768px) {
    .top-banner {
        padding: 14px;
    }

    .header-row {
        align-items: center;
        gap: 8px;
    }

    .section-title {
        font-size: 20px;
        line-height: 1.3;
    }

    .line_blue {
        margin-bottom: 14px !important;
    }

    .chart {
        padding: 12px;
        margin-top: 8px;
    }

    .sales-table-panel {
        max-height: 68vh;
        padding: 10px;
    }

    .table-container .table {
        min-width: 780px;
        font-size: 13px !important;
    }

    .table-container .table thead th,
    .table-container .table tbody td {
        padding: 8px;
        vertical-align: top;
    }

    .modal-content {
        width: 98%;
        max-width: 98%;
        padding: 1rem;
    }

    .close-button {
        right: 0.5rem;
        width: 40px;
    }
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-content {
    background: white;
    width: 1200px; /* Set width */
    max-width: 90%; /* Optional for responsiveness */
    height: auto;
    max-height: 90vh; /* prevent overflow on small screens */
    padding: 2rem;
    position: relative;
    overflow-y: auto;
    border-radius: 10px;
}

.close-button {
    position: absolute;
    top: 1rem;
    right: 2rem;
    background: red;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 10px;
    padding: 0px;
    width: 50px;
    font-size: 2rem;
}

.open-button {
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    cursor: pointer;
}
</style>
